import React, { useRef } from 'react';
import { Box } from 'native-base';
import SignatureCanvas from 'react-signature-canvas';

import { useTheme } from '@springbig/shared';

export type SignatureProps = {
    onChange: (signature: any) => void;
}

const Signature = ({ onChange }: SignatureProps) => {
    const signCanvas = useRef<SignatureCanvas>(null);

    const signature_background = 'white';

    const {
        field_border,
    } = useTheme();
    
    const handleEnd = () => {
        onChange(signCanvas.current?.toDataURL());
    };

    return (
        <Box
            bg={signature_background}
            borderColor={field_border}
            borderWidth={1}
        >
            <SignatureCanvas
                penColor='black'
                canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                onEnd={handleEnd}
                ref={signCanvas}
            />
        </Box>
    );
};

export default Signature;
